"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductContext = void 0;
const bridge_1 = require("@forge/bridge");
const react_1 = require("react");
const useProductContext = () => {
    const [productContext, setProductContext] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        bridge_1.view
            .getContext()
            .then(setProductContext)
            .catch((err) => {
            throw err;
        });
    }, []);
    return productContext;
};
exports.useProductContext = useProductContext;
